import { render, staticRenderFns } from "./HealthcareCard.vue?vue&type=template&id=542d1192&"
import script from "./HealthcareCard.vue?vue&type=script&lang=js&"
export * from "./HealthcareCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports